import { render } from "./MyPersonInfoModify.vue?vue&type=template&id=4b0fa556"
import script from "./MyPersonInfoModify.vue?vue&type=script&lang=js"
export * from "./MyPersonInfoModify.vue?vue&type=script&lang=js"

import "./MyPersonInfoModify.vue?vue&type=style&index=0&id=4b0fa556&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__